import React from "react";
import { createRoot } from "react-dom/client";
// ROOT APP
import App from "./app/App";
import { configureApiClient } from "./app/services/apiClient";

import "./styles/app/app.scss";

configureApiClient();

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
